.description {
  font-size: var(--font-size-xs);
}
